module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("dQWAE"))).then(() => module.bundle.root('aVi2q'));